"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineConfigurationPage = void 0;
var MachineConfiguration_1 = require("./MachineConfiguration");
Object.defineProperty(exports, "MachineConfigurationPage", { enumerable: true, get: function () { return MachineConfiguration_1.MachineConfiguration; } });
